import { gql } from "lib/apolloClient";
import { staffCourseFragment } from "Teacher/modules/TeacherFragments";

export const updateUserCoursesMutation = gql`
  mutation updateUserCourses(
    $removedCourses: [ID!]
    $addedCourses: [ID!]
    $id: ID!
    $filters: CourseFilter
    $courseGradeFilters: CourseGradeFilters
    $isCurriculumProgramFree: Boolean! = false
    $enabledModulesFilters: EnabledModulesFiltersInput
  ) {
    platform {
      updateUserCourses(
        input: {
          removedCourses: $removedCourses
          addedCourses: $addedCourses
          id: $id
        }
      ) {
        ...staffItem
      }
    }
  }
  ${staffCourseFragment.staffCourse}
`;
